<template>
    <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" modal dismissableMask
            :header="video ? video.title : ''" :style="{ width: '56rem', maxWidth: '95vw' }">
        <!-- The iframe only exists while the dialog is open, so closing it stops playback. -->
        <div v-if="visible && video" class="video-frame">
            <iframe :src="embedUrl" :title="video.title" frameborder="0" allowfullscreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        </div>
        <template #footer>
            <a v-if="video" :href="video.videoUrl" target="_blank" rel="noopener" class="btn btn-link btn-sm">
                <i class="pi pi-external-link mr-1"></i>Open on YouTube
            </a>
        </template>
    </Dialog>
</template>

<script>
import {defineComponent} from 'vue'
import Dialog from 'primevue/dialog'
import {youtubeEmbedUrl} from '@/utils/youtube'

export default defineComponent({
    name: "VideoPlayerDialog",
    components: {Dialog},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        video: {
            type: Object,
            default: null
        }
    },
    emits: ['update:visible'],
    computed: {
        embedUrl() {
            return youtubeEmbedUrl(this.video.youtubeVideoId);
        }
    }
})
</script>

<style scoped>
.video-frame {
    position: relative;
    padding-top: 56.25%;
    background: #000;
    border-radius: 4px;
    overflow: hidden;
}

.video-frame iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}
</style>
